module.exports = {"610921100":"城关镇","610921101":"涧池镇","610921102":"蒲溪镇","610921103":"平梁镇","610921104":"双乳镇","610921105":"铁佛寺镇","610921107":"漩涡镇","610921108":"汉阳镇","610921110":"双河口镇","610921112":"观音河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610921.json
// module id = 3012
// module chunks = 0